<template>
    <div class="products_listing">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing">
                <div class="filterbar">
                    <h6>QUICK SEARCH BY</h6>
                    <h4>Category</h4>
                    <ul>
                        <li><router-link to="/shop/products/fabric" :class="[selectedPage.includes('fabric') ? activeClass : '']">Fabrics</router-link></li>
                        <li><router-link to="/shop/products/trim" :class="[selectedPage.includes('trim') ? activeClass : '']">Trim</router-link></li>
                        <li><router-link to="/shop/products/hardware" :class="[selectedPage.includes('hardware') ? activeClass : '']">Hardware</router-link></li>
                        <li><router-link to="/shop/products/sample" :class="[selectedPage.includes('sample') ? activeClass : '']">Sample</router-link></li>
                    </ul>
                    <div class="filter_by" data-v-hardwarefilter>
                        <h6>Filter By</h6>
                        <ul>
                            <li><a href="javascript:;" v-b-toggle.collapse-brand>Brand <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-brand" accordion="my-accordion">
                                <ul>
                                    <li v-for="(lb,lbk) in loadBrands" :key="lbk">
                                        <md-radio v-model="brvalue" :value="lb.ITEMGROUPID" @change="LoadCollection">{{lb.BRAND}}</md-radio>
                                    </li>
                                </ul>
                            </b-collapse>
                            </li>
                            
                            <li><a href="javascript:;" v-b-toggle.collapse-design>Collection <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-design" accordion="my-accordion">
                                <ul>
                                    <li v-for="(lp,lpk) in loadCollection" :key="lpk"><md-checkbox :value="lp.COLLECTION" v-model="form.collection" @change="loadFilter(form)">{{lp.COLLECTION}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>
                            <li><a href="javascript:;" v-b-toggle.collapse-color>Finish/Color <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-color" accordion="my-accordion">    
                                <ul>
                                    <li v-for="(lc,lck) in loadColors" :key="lck"><md-checkbox :value="lc.COLORNAME" v-model="form.colors" @change="loadFilter(form)">{{lc.COLORNAME}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>                          
                        </ul>
                    </div>
                </div>
                <div class="productsbar">
                    <div class="topsection">
                        <h1>All Hardware</h1>
                        <div class="sortby">
                            <label class="sort">Sort By: </label>
                            <v-select 
                            :options="sorting"
                            v-model="form.sort"
                            @input="loadFilter"
                            :reduce="sorting => sorting.value"
                            label="text"
                            :clearable="false"
                            :searchable="false"
                            placeholder="Sorting"
                        ></v-select>
                        </div>
                    </div>
                    <div class="productselectedfilter" v-if="(form.brands.length > 0)||(form.types.length > 0)||(form.collection.length > 0)||(form.colors.length > 0)||(form.use.length > 0)||(form.status.length > 0)||(form.passes.length > 0)">
                        <b-form-tags v-if="form.brands.length > 0" v-model="form.brands" no-outer-focus class="mb-2">
                            <template v-slot="{tagVariant, removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.brands"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						
						<b-form-tags v-if="form.collection.length > 0" v-model="form.collection" no-outer-focus class="mb-2">
                            <template v-slot="{tagVariant, removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.collection"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.colors.length > 0" v-model="form.colors" no-outer-focus class="mb-2">
                            <template v-slot="{tagVariant, removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.colors"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						
                        <a class="clearfilter" href="javascript:;" @click="resetFilter">Clear all</a>
                    </div>
                    <div class="mainproducts">
                        <div class="productbox" v-for="(lp,lpk) in loadProducts" :key="lpk">
                            <a :href="'/shop/hardware/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="imgbox">
                                <b-img class="proimg" :src="lp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                            </a>
                            <div class="contentbox">
                                <div class="smallimages" v-if="lp.DETAIL.length > 0">
                                    <a v-for="(sw,swind) in lp.DETAIL" :key="swind" :href="'/shop/hardware/'+lp.ITEMID+'/'+sw.INVENTCOLORID" class="forborder" @mouseover="loadswatchdata(sw,lp.ITEMID,sw.INVENTCOLORID,$event)">
                                        <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                    </a>
                                    <a :href="'/shop/hardware/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="forborder" v-if="lp.TOTALSWATCH > 5"><div class="moreprod">+{{lp.TOTALSWATCH - 5}}</div></a>
                                </div>
                                <h4><a :href="'/shop/hardware/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID">{{lp.ITEMNAME}} / <span class="clname">{{lp.DETAIL[0].COLORNAME}}</span></a></h4>
                                <p v-if="lp.DETAIL[0].SHORTDESCRIPTION != ''">{{lp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                <p v-if="lp.DETAIL[0].PRICE">${{lp.DETAIL[0].PRICE}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="propagination">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                        <div class="itemspage">
                            <label class="pageitem">Items per page :</label>
                            <v-select 
                                :options="itemspage"
                                v-model="form.items"
                                @input="loadFilter"
                                :clearable="false"
                                :searchable="false"
                                placeholder="100"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    CommonHead,
    CommonFoot,
    'v-select': vSelect,
    Loading
  },
  computed:{
        selectedPage(){
            return this.$route.path;
        }
  },
  mounted(){
        this.isLoading = true;
        this.$store.dispatch("loadHardwareBrands").then(loadBrands => {
            this.loadBrands = loadBrands.data;
        });
        if(this.$route.query.brand){
			this.$store.dispatch("loadCollection",this.$route.query.brand).then(loadCollection => {
                this.loadCollection = loadCollection.data;
            });
			
			this.$store.dispatch("loadHardwareColors",this.$route.query.brand).then(loadColors => {
                this.loadColors = loadColors.data;
            });
		}else{
            this.form.brands=["HA"];
            this.brvalue = "HA";
			this.$store.dispatch("loadCollection",this.form.brands).then(loadCollection => {
                this.loadCollection = loadCollection.data;
            });
			
			this.$store.dispatch("loadHardwareColors",this.form.brands).then(loadColors => {
                this.loadColors = loadColors.data;
            });
			this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
		}
        this.PageloadFilter();
  },
  data(){
      return{
        activeClass:'active',
        loadProducts:[],
        loadBrands:{},
        loadColors:{},
        loadCollection:{},
        loadUses:{},
        rows: 100,
        perPage: 100,
        currentPage: 1,
        sorting: [
          { value: 'newest', text: 'Newest'},
          { value: 'abccode', text: 'Popularity'},
          { value: 'lowtohigh', text: 'Price: Low to High'},
          { value: 'hightolow', text: 'Price: High to Low'}
        ],
        itemspage: [
          { value: '100', text: ' 100 '},
          { value: '200', text: ' 200 '},
          { value: '300', text: ' 300 '}
        ],
        quantity: 1,
        form:{
            brands: [],
            colors: [],
            collection: [],
            items:100,
            sort:'newest',
            page:1 
        },
        brvalue: '',
        isLoading: false,
          breadcrumb: [
          {
            text: 'Home',
            href: '/'
          },
          {
            text: 'Hardware',
            active: true
          }
        ]
      };
  },
  methods: {
        paginationChange(page){
            this.form.page = page;
            this.loadFilter();
        },
		LoadCollection(val){
            this.form.brands = [this.brvalue];
            this.form.collection = [];
            this.form.colors = [];
            this.$store.dispatch("loadCollection",this.form.brands).then(loadCollection => {
                this.loadCollection = loadCollection.data;
            });
			
			this.$store.dispatch("loadHardwareColors",this.form.brands).then(loadColors => {
                this.loadColors = loadColors.data;
            });
			this.loadFilter();
		},
        loadFilter(){
            this.isLoading = true;
            let url = [];
            
            if(this.form.brands.length > 0){
                url["brand"] = this.form.brands.join();
				this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
            }
           
            if(this.form.colors.length > 0){
                url["color"] = this.form.colors.join();
				this.$root.$emit('bv::toggle::collapse', 'collapse-color');
            }
            if(this.form.collection.length > 0){
                url["collection"] = this.form.collection.join();
				this.$root.$emit('bv::toggle::collapse', 'collapse-design');
            }
           
            if(this.form.items != null){
                url["items"] = this.form.items;
            }
            if(this.form.sort != null){
                url["sort"] = this.form.sort;
            }
            url["page"] = this.form.page;
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadhardwareProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		PageloadFilter(){
            let url = [];
            
            if(this.$route.query.brand){
				url["brand"] = this.$route.query.brand;
				this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
            }else{
                this.form.brands=["HA"];
                this.brvalue = "HA";
                url["brand"] = "HA";
            }
            if(this.$route.query.color){
				url["color"] = this.$route.query.color;
				this.$root.$emit('bv::toggle::collapse', 'collapse-color');
			}
            if(this.$route.query.collection){
				url["collection"] = this.$route.query.collection;
				this.$root.$emit('bv::toggle::collapse', 'collapse-design');
			}
            
            if(this.$route.query.items){
                url["items"] = this.$route.query.items;
            }else{
                url["items"] = this.form.items;
            }
            if(this.$route.query.sort){
                url["sort"] = this.$route.query.sort;
            }else{
                url["sort"] = this.form.sort;
            }
            if(this.$route.query.page){
                url["page"] = this.$route.query.page;
                this.form.page = this.$route.query.page;
            }else{
                url["page"] = this.form.page;
            }
            
            this.$router.push({query: url });
            
            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadhardwareProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		AciveFilter(){
            
            if(this.$route.query.brand){
                //this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
                this.brvalue = this.$route.query.brand;
				this.form.brands=this.$route.query.brand.split(',');
			}
			
			if(this.$route.query.color){
				//this.$root.$emit('bv::toggle::collapse', 'collapse-color');
				this.form.colors=this.$route.query.color.split(',');
			}
			if(this.$route.query.collection){
				//this.$root.$emit('bv::toggle::collapse', 'collapse-design');
				this.form.collection=this.$route.query.collection.split(',');
			}
			
            if(this.$route.query.items){
			    this.form.items=this.$route.query.items;
			}
            if(this.$route.query.sort){
			    this.form.sort=this.$route.query.sort;
			}
        },
        refreshTag(tag){
            if(tag == 'HA' || tag == 'HB' || tag == 'HF' || tag == 'HG'){
                this.brvalue = 'HA';
                this.form.brands= ["HA"];
            }
            setTimeout(function () { this.loadFilter() }.bind(this), 500);
        },
        resetFilter(){
            this.form.brands= ["HA"];
            this.form.colors= [];
            this.form.collection= [];
            
            this.form.items=100;
            this.form.sort='newest';
            this.form.page=1; 
            this.loadFilter();
        },
        loadswatchdata(detail,itemid,inventcolorid,event){
            $(".productbox .imgbox").removeClass("active");
            $(event.target).parents(".productbox").children(".imgbox").addClass("active");
            let buildurl = '';
            if(inventcolorid != ''){
                buildurl = '/shop/hardware/'+itemid+'/'+inventcolorid;
            }else{
                buildurl = '/shop/hardware/'+itemid;
            }
            let hoverimg = detail.MEDIUM_IMAGE;
            let colornamehvr = detail.COLORNAME
            $(event.target).parents(".productbox").children(".imgbox").attr("href",buildurl);
            $(event.target).parents(".productbox").children(".imgbox").children(".proimg").attr("src",hoverimg);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("href",buildurl);
            $(event.target).parents(".contentbox").children("h4").children("a").children(".clname").text(colornamehvr);
        }
    },
	
};
</script>
<style>
    .filterbar .filter_by[data-v-hardwarefilter] ul li ul li .md-checkbox .md-checkbox-label{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 170px;
    }
</style>